<div class="container content-container content-container-md" *ngIf="!isLoading">
  <form [formGroup]="districtForm" novalidate (ngSubmit)="saveDistrictInfo()">
    <h1 class="pageHeading">{{formTitle}}</h1>

    <div class="grey">{{ 'DISTRICT_FORM.BOARD_ID' | translate:{ id: districtForm.value.id } }}</div>
    <h2 class="subtitle">{{ districtForm.value.boardName }}</h2>
    <div class="well">
      <div class="container">

          <div class="row">
            <div class="col-6">
              <label>{{ 'DISTRICT_FORM.BOARD_NAME' | translate }}</label>
              <input type="text" class="form-control" [formControlName]="districtFormFields.boardName" [placeholder]="'DISTRICT_FORM.BOARD_NAME' | translate">
            </div>
            <div class="col-3">
              <label>{{ 'DISTRICT_FORM.ABBREV' | translate }}</label>
              <input type="text" class="form-control" [formControlName]="districtFormFields.abbrev" [placeholder]="'DISTRICT_FORM.ABBREV' | translate">
            </div>
            <div class="col-3">
              <label>{{ 'DISTRICT_FORM.VALIDATION' | translate }}</label>
              <select class="form-control" [formControlName]="districtFormFields.isValidated">
                <option *ngFor="let item of [true, false]" [value]="item">{{ item ? ('DISTRICT_FORM.VALIDATED' | translate) : ('DISTRICT_FORM.NOT_VALIDATED' | translate) }}</option>
              </select>
            </div>
          </div>

          <div class="row">
            <div class="col-3">
              <label>{{ 'DISTRICT_FORM.COUNTRY_LABEL' | translate }}</label>
              <select class="form-control" [formControlName]="districtFormFields.countryCode" (ngModelChange)="changeCountry()">
                <option value="">{{ 'DISTRICT_FORM.COUNTRY' | translate }}</option>
                <option *ngFor="let country of countries" [ngValue]="country.CountryCode">{{ country.Name }}</option>
              </select>
            </div>
            <div class="col-3">
              <label>{{ 'DISTRICT_FORM.REGION' | translate }}</label>
              <select class="form-control" [formControlName]="districtFormFields.regionCode">
                <option value="">{{ 'DISTRICT_FORM.PROVINCESTATE' | translate }}</option>
                <option *ngFor="let region of country?.Regions" [ngValue]="region.RegionCode">{{ region.Name }}</option>
              </select>
            </div>
          </div>

          <div class="row" *ngIf="displayContent">
            <div class="col-12">
              <ng-content></ng-content>
            </div>
          </div>

          <div class="row">
            <div class="col-6">
              <div class="well game-access-box">
                <label><u><b>{{ 'DISTRICT_FORM.ONTARIO_NOVA_SCOTIA_DISTRICT_ACTION_GAME_ACCESS' | translate }}</b></u></label>
                <div class="action-game-access-options">
                  <label>
                    <input type="radio" [formControlName]="districtFormFields.gameAccess" value="{{gameAccess.Blocked}}" [disabled]="!gameAccessSetting">
                    {{ 'DISTRICT_FORM.ACTION_GAME_BLOCKED' | translate }}
                  </label>
                  <label>
                    <input type="radio" [formControlName]="districtFormFields.gameAccess" value="{{gameAccess.OptIn}}" [disabled]="!gameAccessSetting">
                    {{ 'DISTRICT_FORM.PARENT_OPTIN' | translate }}
                  </label>
                  <label>
                    <input type="radio" [formControlName]="districtFormFields.gameAccess" value="{{gameAccess.Open}}" [disabled]="!gameAccessSetting">
                    {{ 'DISTRICT_FORM.OPEN' | translate }}
                  </label>
                </div>
              </div>
            </div>
            <div class="col-6">
              <div class="row">
                <div class="col-12 btn-toggle-col">
                  <div class="btn-group btn-toggle">
                    <button type="button" (click)="districtForm.get(districtFormFields.isHomeUpsellDisabled)?.setValue(true)" class="btn btn-sm" [ngClass]="{
                        active: districtForm.value[districtFormFields.isHomeUpsellDisabled],
                        'btn-default': !districtForm.value[districtFormFields.isHomeUpsellDisabled],
                        'btn-primary': districtForm.value[districtFormFields.isHomeUpsellDisabled]
                      }">
                      {{ 'DISTRICT_FORM.DISABLED' | translate }}
                    </button>
                    <button type="button" (click)="districtForm.get(districtFormFields.isHomeUpsellDisabled)?.setValue(false)" class="btn btn-sm" [ngClass]="{
                        active: !districtForm.value[districtFormFields.isHomeUpsellDisabled],
                        'btn-default': districtForm.value[districtFormFields.isHomeUpsellDisabled],
                        'btn-primary': !districtForm.value[districtFormFields.isHomeUpsellDisabled]
                      }">
                      {{ 'DISTRICT_FORM.ENABLED' | translate }}
                    </button>
                  </div>
                  <label class="control-label spacer-left" [tooltip]="'DISTRICT_FORM.WHEN_DISABLED_WILL_NO_LONGER' | translate">{{ 'DISTRICT_FORM.STUDENT_UPSELL' | translate }} <span class="fa fa-info-circle grey"></span></label>
                </div>
              </div>

              <div class="row">
                <div class="col-12 btn-toggle-col">
                  <div class="btn-group btn-toggle">
                    <button type="button" (click)="districtForm.get(districtFormFields.isPrivacyModeEnabled)?.setValue(true)" class="btn btn-sm" [ngClass]="{
                        active: districtForm.value[districtFormFields.isPrivacyModeEnabled],
                        'btn-default': !districtForm.value[districtFormFields.isPrivacyModeEnabled],
                        'btn-primary': districtForm.value[districtFormFields.isPrivacyModeEnabled]
                      }">
                      {{ 'DISTRICT_FORM.ON' | translate }}
                    </button>
                    <button type="button" (click)="districtForm.get(districtFormFields.isPrivacyModeEnabled)?.setValue(false)" class="btn btn-sm" [ngClass]="{
                        active: !districtForm.value[districtFormFields.isPrivacyModeEnabled],
                        'btn-default': districtForm.value[districtFormFields.isPrivacyModeEnabled],
                        'btn-primary': !districtForm.value[districtFormFields.isPrivacyModeEnabled]
                      }">
                      {{ 'DISTRICT_FORM.OFF' | translate }}
                    </button>
                  </div>
                  <label [tooltip]="'DISTRICT_FORM.WHEN_ACTIVATED_IT_HIDES_TEACHER' | translate">{{ 'DISTRICT_FORM.PRIVACY_MODE' | translate }} <span class="fas fa-info-circle grey"></span></label>
                </div>
              </div>

              <div class="row mb-0">
                <div class="col-12 btn-toggle-col">
                  <div class="btn-group btn-toggle">
                    <button type="button" (click)="districtForm.get(districtFormFields.isParentUpsellEnabled)?.setValue(true)" class="btn btn-sm" [ngClass]="{
                        active: districtForm.value[districtFormFields.isParentUpsellEnabled],
                        'btn-default': !districtForm.value[districtFormFields.isParentUpsellEnabled],
                        'btn-primary': districtForm.value[districtFormFields.isParentUpsellEnabled]
                      }">
                      {{ 'DISTRICT_FORM.ON' | translate }}
                    </button>
                    <button type="button" (click)="districtForm.get(districtFormFields.isParentUpsellEnabled)?.setValue(false)" class="btn btn-sm" [ngClass]="{
                        active: !districtForm.value[districtFormFields.isParentUpsellEnabled],
                        'btn-default': districtForm.value[districtFormFields.isParentUpsellEnabled],
                        'btn-primary': !districtForm.value[districtFormFields.isParentUpsellEnabled]
                      }">
                      {{ 'DISTRICT_FORM.OFF' | translate }}
                    </button>
                  </div>
                  <label [tooltip]="'DISTRICT_FORM.WHEN_ACTIVATED_GUARDIAN_GIFT_APP' | translate">
                    {{ 'DISTRICT_FORM.GUARDIAN_GIFT_APP_LINK_BONUSES' | translate }}
                    <span class="fas fa-info-circle grey"></span>
                  </label>
                </div>
              </div>
            </div>
          </div>

          <div class="row">
            <div class="col-6">
              <div class="row">
                <div class="col-12">
                  <h2 class="ml-0 mt-0">
                    {{ 'DISTRICT_FORM.DISTRICT_DASHBOARD' | translate }}
                  </h2>
                </div>
              </div>

              <div class="row">
                <div class="col-12">
                  <div style="display: flex">
                    <div class="btn-toggle-col">
                      <div class="btn-group btn-toggle">
                        <button type="button" (click)="districtForm.get(districtFormFields.dashboard.isClassFilterEnabled)?.setValue(true)" class="btn btn-sm" [ngClass]="{
                            active: districtForm.value[districtFormFields.dashboard.isClassFilterEnabled],
                            'btn-default': !districtForm.value[districtFormFields.dashboard.isClassFilterEnabled],
                            'btn-primary': districtForm.value[districtFormFields.dashboard.isClassFilterEnabled]
                          }">
                          {{ 'DISTRICT_FORM.ON' | translate }}
                        </button>
                        <button type="button" (click)="districtForm.get(districtFormFields.dashboard.isClassFilterEnabled)?.setValue(false)" class="btn btn-sm" [ngClass]="{
                            active: !districtForm.value[districtFormFields.dashboard.isClassFilterEnabled],
                            'btn-default': districtForm.value[districtFormFields.dashboard.isClassFilterEnabled],
                            'btn-primary': !districtForm.value[districtFormFields.dashboard.isClassFilterEnabled]
                          }">
                          {{ 'DISTRICT_FORM.OFF' | translate }}
                        </button>
                      </div>
                      <label [tooltip]="'DISTRICT_FORM.ALLOW_DISTRICT_LEADERS_TO_FILTER' | translate">
                        {{ 'DISTRICT_FORM.CLASS_FILTER' | translate }}
                        <span class="fas fa-info-circle grey"></span>
                      </label>
                    </div>

                    <div class="btn-toggle-col ml-5">
                      <div class="btn-group btn-toggle">
                        <button type="button" (click)="districtForm.get(districtFormFields.dashboard.isDistrictComparisonEnabled)?.setValue(true)" class="btn btn-sm" [ngClass]="{
                            active: districtForm.value[districtFormFields.dashboard.isDistrictComparisonEnabled],
                            'btn-default': !districtForm.value[districtFormFields.dashboard.isDistrictComparisonEnabled],
                            'btn-primary': districtForm.value[districtFormFields.dashboard.isDistrictComparisonEnabled]
                          }">
                          {{ 'DISTRICT_FORM.ON' | translate }}
                        </button>
                        <button type="button" (click)="districtForm.get(districtFormFields.dashboard.isDistrictComparisonEnabled)?.setValue(false)" class="btn btn-sm" [ngClass]="{
                            active: !districtForm.value[districtFormFields.dashboard.isDistrictComparisonEnabled],
                            'btn-default': districtForm.value[districtFormFields.dashboard.isDistrictComparisonEnabled],
                            'btn-primary': !districtForm.value[districtFormFields.dashboard.isDistrictComparisonEnabled]
                          }">
                          {{ 'DISTRICT_FORM.OFF' | translate }}
                        </button>
                      </div>
                      <label [tooltip]="'DISTRICT_FORM.IN_DISTRICT_DASHBOARDS_ADMIN_CAN' | translate">
                        {{ 'DISTRICT_FORM.DISTRICT_COMPARISON' | translate }}
                        <span class="fas fa-info-circle grey"></span>
                      </label>
                    </div>
                  </div>

                </div>
              </div>
            </div>
          </div>

          <div class="row" *ngIf="showButtonsRow">
            <div class="col-12 buttons-row">
              <button type="submit" class="btn btn-lg btn-primary ml-auto">
                {{ 'DISTRICT_FORM.SAVE' | translate }}
              </button>
            </div>
          </div>
        </div>
      </div>
  </form>
</div>

<div *ngIf="isLoading || isContentLoading">
  <div id="LogoAnim" class="animated-loading-logo">
    <img src="images/Logo-Animated.gif">
  </div>
</div>